module.exports = __webpack_public_path__ + "static/media/c2bannerModulE_small.4388b632.jpg";